export enum AccessFunctionalityTypeEnum {
    None = 0,
    Device = 1,
    Tag = 3,
    PageConfiguration = 5,
    Group = 6,
    Trending = 7,
    Reporting = 8,
    Alarming = 9,
    User = 11,
    Role = 12,
    Organization = 13,
    DynamicAllocation = 14,
    Tow = 15,
    NotificationList = 16,
    AlarmSchedule = 17,
    AlarmScheme = 18,
    List = 19,
    CommunicationMonitor = 20,
    MetaTag = 21,
    AttachedDocument = 22,
    Memo = 23,
    MemoAutoText = 24,
    LiquidProduction = 25,
    GasAnalysisConfiguration = 26,
    Analytics = 27,
    Accounting = 28,
    Well = 30,
    Pad = 31,
    Field = 32,
    DataFileImport = 33,
    HMIView = 34,
    FormTemplate = 35,
    FormInstance = 36,
    MappingConfiguration = 37,
    AuditReporting = 38,
    Dashboard = 39,
    ObjectTagValuesConfiguration = 40,
}
